import { siteName, businessName } from "./domains";

// Unique businesses seen in each channel (Market Overview stat cards).
export function channelTotals(results) {
  return {
    ppc: [...new Set(results.flatMap(r => r.paid.map(a => siteName(a))))].length,
    gbp: [...new Set(results.flatMap(r => r.localPack.map(l => businessName(l, "gbp"))))].length,
    seo: [...new Set(results.flatMap(r => r.organic.map(o => siteName(o))))].length,
    shopping: [...new Set(results.flatMap(r => r.shopping.map(s => businessName(s, "shopping"))))].length,
    lsa: [...new Set(results.flatMap(r => r.lsa.map(l => businessName(l, "lsa"))))].length,
  };
}

// PPC advertisers ranked by how often their ads were seen.
// Each advertiser keeps one copy of each distinct ad (by title).
export function ppcAdvertisers(results) {
  const adMap = {};
  results.forEach(r => {
    r.paid.forEach(ad => {
      const key = siteName(ad);
      if (!adMap[key]) adMap[key] = { name: key, count: 0, locations: new Set(), ads: [] };
      adMap[key].count++;
      adMap[key].locations.add(r.location);
      if (!adMap[key].ads.find(a => a.title === ad.title)) adMap[key].ads.push(ad);
    });
  });
  return Object.values(adMap).sort((a, b) => b.count - a.count);
}
